export default "__VITE_PUBLIC_ASSET__67dd14bd__"